<template>
  <div>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: "branch-jackpots"
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/branch/jackpots/index.vue